import { ChangeDetectionStrategy, Component, inject } from "@angular/core";

import { SidebarComponent } from "../../sidebar/sidebar.component";
import { NavService } from "../nav.service";

@Component({
	selector: "ic-root",
	imports: [SidebarComponent],
	templateUrl: "./root.component.html",
	styleUrl: "./root.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RootComponent {
	private readonly navService = inject(NavService);

	protected menuItems = this.navService.menuItems;
}
